import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryMdm } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { useEffect } from "react";

interface ReasonForReturnEntity {
  id: number;
  code: string;
  name: string;
  description?: string;
  note?: string;
  active: boolean;
  createBy: number;
  createDate: string | null;
  updateBy: number;
  updateDate: string | null;
}
type Props = {
  onReload?: () => void;
  itemDetail?: ReasonForReturnEntity | null | undefined;
};
const CreateReasonForReturn = ({ onReload, itemDetail }: Props) => {
  console.log("CreateReasonForReturn itemDetail", itemDetail);
  const entity: ReasonForReturnEntity = {
    id: 0,
    code: "",
    name: "",
    active: false,
    createBy: 0,
    createDate: null,
    updateBy: 0,
    updateDate: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      code: (value) => (value ? null : "Mã lý do trả hàng không được để trống"),
      name: (value) =>
        value ? null : "Tên lý do trả hàng không được để trống",
    },
  });

  const handleCreateReasonForReturn = async (
    dataSubmit: ReasonForReturnEntity
  ) => {
    open();
    console.log("dataSubmit", dataSubmit);
    let datahandle = dataSubmit;
    if (itemDetail) {
      // Xóa lastUpdateBy và lastUpdateDate nếu có trong object
      const { lastUpdateBy, lastUpdateDate, ...rest } = dataSubmit as any;
      datahandle = {
        ...rest,
        id: itemDetail.id,
      };
    } else {
      // Thêm mới: thêm code vào trước name nếu chưa có
      datahandle = {
        ...dataSubmit,
        name: dataSubmit.name.startsWith(`[${dataSubmit.code}]`)
          ? dataSubmit.name
          : `[${dataSubmit.code}]${dataSubmit.name}`,
      };
    }
    let api = itemDetail
      ? "/api/v1/TblDmReturnReason/update"
      : "/api/v1/TblDmReturnReason/create";
    const dataApi = await repositoryMdm.post<
      MessageResponse<ReasonForReturnEntity>
    >(`${api}`, datahandle);
    if (dataApi?.success) {
      modals.closeAll();
      onReload && onReload();
      setTimeout(() => {
        itemDetail
          ? NotificationExtension.Success("Cập nhật thành công !")
          : NotificationExtension.Success("Thêm thành công !");
      }, 1000);
    } else {
      itemDetail
        ? NotificationExtension.Fails("Đã xảy ra lỗi khi cập nhật !")
        : NotificationExtension.Fails("Đã xảy ra lỗi khi thêm mới !");
    }
    close();
  };

  useEffect(() => {
    if (itemDetail) {
      form.setValues({
        ...itemDetail,
      });
    }
  }, [itemDetail]);
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: ReasonForReturnEntity) => {
          handleCreateReasonForReturn(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={12}>
            <TextInput
              label={"Mã lý do trả hàng"}
              placeholder={"Nhập mã lý do trả hàng"}
              withAsterisk
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Tên lý do trả hàng"}
              placeholder={"Nhập tên lý do trả hàng"}
              withAsterisk
              w={"100%"}
              {...form.getInputProps("name")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox
              label={"Sử dụng"}
              checked={form.getValues().active}
              {...form.getInputProps("active")}
              onChange={(event) => {
                form.setFieldValue("active", event.currentTarget.checked);
              }}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateReasonForReturn;
